'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var Space = require('../../Space/src/Space.js');
var Sheet_module = require('../styles/Sheet.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description Sheet Header component.
 *
 * @component
 * @example
 * ```jsx
 * <Sheet.Header>content</Sheet>
 * ```
 */
const Header = React__namespace.forwardRef((props, ref) => {
    const { title, subtitle, className, children, ...restProps } = props;
    const cx = reactUtils.useStyles(Sheet_module.default);
    return (React__namespace.createElement("div", { ref: ref, className: cx(className, 'header'), ...restProps },
        title || subtitle ? (React__namespace.createElement(Space.Space, { direction: "vertical", size: 0, className: cx('title-wrapper') },
            title && React__namespace.createElement("div", { className: cx('title') }, title),
            subtitle && React__namespace.createElement("div", { className: cx('subtitle') }, subtitle))) : null,
        children));
});
Header.defaultProps = {};
Header.displayName = 'Header';

exports.Header = Header;
//# sourceMappingURL=Header.js.map
